// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z5Xka","location":"Header_location__1HaOv"};